import { Button, Table } from 'antd';
import { EditPageAction } from './editPageAction';
import { ModalTrigger } from '@arivaa-react/components/modal';
import { PlusOutlined } from '@ant-design/icons';
import { AddPageForm } from './addPageForm';

export function PagesTable({ pages }) {
  return (
    <div className="smart-table">
      <ModalTrigger
        modalProps={{
          title: 'Create Page',
          className: `add-record-modal`,
          footer: null,
        }}
        content={<AddPageForm />}
      >
        <Button type="primary" icon={<PlusOutlined />}>
          <span className="text">Create Page</span>
        </Button>
      </ModalTrigger>
      <Table
        bordered={true}
        rowKey={'key'}
        showSorterTooltip={false}
        dataSource={pages}
        columns={[
          {
            title: 'Page Title',
            dataIndex: 'title',
          },
          {
            title: 'Actions',
            key: 'Actions',
            render: (_, record) => (
              <div className="row-actions">
                <EditPageAction pageKey={record.pageKey} />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
